'use strict'

import css from './order-create.styles.scss'
import template from './order-create.template.pug'

class CreateOrderController {
  constructor($mdDialog, SessionService, UserService) {
    'ngInject'
    Object.assign(
      this,
      { $mdDialog, SessionService, UserService },
      {
        user: SessionService.currentUser.user,
        isDifferentContact: false,
        newUserPhone: null,
        contact: {},
        comment: undefined,
      },
    )
    if (this.tasksite) this.order.selectTasksite(this.tasksite)
    this.tasksiteDetailVisible = false
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  onChangePickUpTime() {
    const startingTimeValue = parseInt(this.order.startingTime)
    const finishingTimeValue = parseInt(this.order.finishingTime)
    if (startingTimeValue && finishingTimeValue) {
      const pickUpTimeTooShort = finishingTimeValue - startingTimeValue < 8
      this.createOrderWithTasksiteForm.startingTime.$setValidity('tooShort', !pickUpTimeTooShort)
      this.createOrderWithTasksiteForm.finishingTime.$setValidity('tooShort', !pickUpTimeTooShort)
    }
  }

  send() {
    if (this.isDifferentContact) {
      const contactString = `Kontaktperson vor Ort: ${this.contact.name} (${this.contact.phone})`
      this.order.comment = this.comment ? `${contactString}; ${this.comment}` : contactString

      if (this.contact.email) {
        this.order.contactEmail = this.contact.email
      }
    } else {
      this.order.comment = this.comment
    }

    if (this.order.comment) {
      this.order.comment = this.order.comment.replaceAll('\n', '; ') // replace new lines, which can not be handled by tegos API
    }

    return Promise.resolve()
      .then(() => {
        if (!this.isDifferentContact && !this.user.phone && this.newUserPhone) {
          return this.UserService.patchMe({ phone: this.newUserPhone }).then(() => {
            this.SessionService.currentUser.user.phone = this.newUserPhone
          })
        }
        return Promise.resolve()
      })
      .then(() => this.order.send())
      .then((result) => {
        this.$mdDialog.hide(result)
      })
  }

  toggleTasksiteDetail() {
    this.tasksiteDetailVisible = !this.tasksiteDetailVisible
  }

  isValidStartingTime(minTimeValue) {
    return !this.order.finishingTime || parseInt(this.order.finishingTime) >= minTimeValue
  }

  isValidFinishingTime(maxTimeValue) {
    return !this.order.startingTime || parseInt(this.order.startingTime) <= maxTimeValue
  }
}

export const orderCreateComponent = {
  controller: CreateOrderController,
  controllerAs: '$ctrl',
  clickOutsideToClose: false,
  escapeToClose: true,
  template: template({ css }),
  fullscreen: true,
  bindToController: true,
}

export const orderCreateConfig = ($mdDialogProvider) => {
  'ngInject'

  $mdDialogProvider.addPreset('orderCreateDialog', {
    options: () => {
      return orderCreateComponent
    },
  })
}



// WEBPACK FOOTER //
// ./app/orders/containers/order-create/order-create.component.js